module.exports = __webpack_public_path__ + "img/hn.80a74b51.svg";